import { Content } from "./styles";

const ScheduleCellHeader = ({
    children
}) => {
    return (
        <th>
            <Content>{children}</Content>
        </th>
    );
}

export default ScheduleCellHeader;